import { AppColors } from "@/styles/colors"
import { Button } from "@chakra-ui/react"
import { ChevronLeft, Plus } from "lucide-react"
import { Dispatch, SetStateAction } from "react"

interface Props {
    loadingTomar: boolean
    isPending: boolean
    isEnProceso: boolean
    loadingSubmit: boolean
    isFormComplete: boolean
    setOpenInforme: Dispatch<SetStateAction<boolean>>
    handleTomar: () => Promise<void>
    handleBack: () => void
}

export const MBDetailButtons = ({
    isEnProceso,
    isPending,
    loadingTomar,
    loadingSubmit,
    isFormComplete,
    setOpenInforme,
    handleTomar,
    handleBack
}: Props) => {

    return (
        <>
            {isPending && (
                <Button
                    bgColor={AppColors.GREEN_PRIMARY}
                    fontWeight={600}
                    paddingX="12px"
                    onClick={handleTomar}
                    loading={loadingTomar}
                    disabled={loadingTomar}
                >
                    <Plus />
                    Tomar
                </Button>
            )}
            {isEnProceso && (
                <Button
                    bgColor={AppColors.GREEN_PRIMARY}
                    fontWeight={600}
                    paddingX="12px"
                    onClick={() => setOpenInforme(true)}
                    disabled={!isFormComplete || loadingSubmit}
                    loading={loadingSubmit}
                >
                    <Plus />
                    Completar y enviar
                </Button>
            )}
            <Button onClick={handleBack} fontWeight={600} padding="12px" >
                <ChevronLeft />
                Volver
            </Button>
        </>
    )
}